module.exports = __webpack_public_path__ + "media/manage/default-notice-only-45398758.png";